module.exports = __webpack_public_path__ + "img/limite-inicial.6dbbe603.svg";